module.exports = __webpack_public_path__ + "static/media/settings.9c3b3d5e.jpg";